<div id="marketplace-feedback-modal" class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>

  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="mb-4">
    <p>
      <fa-icon class="me-2" icon="info-circle"></fa-icon>
      <span [innerHTML]="helpText"></span>
    </p>
  </div>

  <formly-form [fields]="fields" [form]="form"></formly-form>
</div>

<div class="modal-footer">
  <button
    [class.loading]="loadingService.loading$ | async"
    (click)="modal.dismiss()"
    class="btn btn-outline-secondary"
    type="button"
  >
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    (click)="markSelectedAsSold()"
    class="btn btn-primary"
    type="button"
  >
    {{ "Mark selected as sold" | translate }}
  </button>
</div>
